<template>
    <div class="trend-query-box">
        <div class="f-clearfix select-item" v-if="!hideClasses">
            <div class="f-fl select-item-main" v-if="!hideClasses">
                条件筛选
                <i
                    class="ico"
                    :class="showMoreCondition ? 'ico-up' : 'ico-down' "
                    @click="showMoreCondition= !showMoreCondition"
                ></i>
            </div>
            <div class="f-fr select-item-right get-focus">
                <input type="text" placeholder="请输入要搜索的内容" v-model.trim="params.searchContent">
                <i class="ico ico-search show-search-icon" @click="doSearch"></i>
                <i class="ico ico-search icon-search-active hidden-search-icon"></i>
            </div>
        </div>
        <div v-if="!hideClasses" class="select-words-wrap" v-show="showMoreCondition">
            <p class="f-clearfix">
                <a
                    class="g-laboratory-a"
                    href="javascript:;"
                    :class="{'g-laboratory-a-active': item.isActive}"
                    v-for="(item,index) in pageConf.classes"
                    @click="changeSelect(item)"
                    :key="index"
                >{{ item.name }}</a>
            </p>
            <p class="f-clearfix">
                <a
                    class="g-laboratory-a"
                    href="javascript:;"
                    :class="{'g-laboratory-a-active': item.isActive}"
                    s
                    v-for="(item,index) in pageConf.times"
                    @click="changeSelect(item,'times')"
                    :key="index"
                >{{ item.name }}</a>
            </p>
        </div>
        <div class="select-words-wrap" v-else>
            <p class="f-clearfix" style="display: inline-block">
                <a
                    class="g-laboratory-a"
                    href="javascript:;"
                    :class="{'g-laboratory-a-active': item.isActive}"
                    v-for="(item,index) in pageConf.times"
                    @click="changeSelect(item,'times')"
                    :key="index"
                >{{ item.name }}</a>
            </p>
            <div class="f-fr select-item-right get-focus" style="display: inline-block">
                <input type="text" placeholder="请输入要搜索的内容" v-model="params.searchContent">
                <i class="ico ico-search show-search-icon" @click="doSearch"></i>
                <i class="ico ico-search icon-search-active hidden-search-icon"></i>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "~Assets/sass/pages/v4/laboratory/radar.scss";
</style>

<script>
export default {
    name: "radar_query_box.vue",
    props: ["hideClasses"],
    data() {
        return {
            showMoreCondition: true,
            params: {
                searchContent: "",
                time: 3,
                classId: ""
            },
            pageConf: {
                classes: [
                    {
                        name: "英雄",
                        isActive: false,
                        classesId: 1
                    },
                    {
                        name: "攻略",
                        isActive: false,
                        classesId: 2
                    },
                    {
                        name: "赛事",
                        isActive: false,
                        classesId: 3
                    },
                    {
                        name: "战队",
                        isActive: false,
                        classesId: 4
                    },
                    {
                        name: "大V",
                        isActive: false,
                        classesId: 5
                    }
                ],
                times: [
                    {
                        name: "最近三天",
                        isActive: true,
                        value: 3
                    },
                    {
                        name: "最近一周",
                        isActive: false,
                        value: 7
                    },
                    {
                        name: "最近一月",
                        isActive: false,
                        value: 30
                    }
                ]
            }
        };
    },
    components: {},
    mounted() {},
    methods: {
        changeSelect(item, type = "classes") {
            if (type == "classes") {
                item.isActive = !item.isActive;
                this.params.classId = item.isActive ? item.classesId : "";
                this.pageConf.classes.map(i => {
                    if (i.classesId != item.classesId) {
                        i.isActive = false;
                    }
                    return i;
                });
            } else {
                item.isActive = true;
                this.params.time = item.value;
                this.pageConf.times.map(i => {
                    if (i.value != item.value) {
                        i.isActive = false;
                    }
                    return i;
                });
            }
            this.doSearch();
        },
        doSearch() {
            this.$emit("search", this.params);
        }
    }
};
</script>

